export const apimName = "ReplenishmentAppApi";
